const openDashboardModalLayers = [];
const handledDashboardModalEscapeEvents = new WeakSet();

const syncDashboardModalStackState = () => {
  const topmostIndex = openDashboardModalLayers.length - 1;
  openDashboardModalLayers.forEach((entry, index) => {
    entry.isTopmost.value = index === topmostIndex;
  });
};

export const registerDashboardModalLayer = entry => {
  const existingIndex = openDashboardModalLayers.indexOf(entry);
  if (existingIndex >= 0) openDashboardModalLayers.splice(existingIndex, 1);

  openDashboardModalLayers.push(entry);
  syncDashboardModalStackState();
};

export const unregisterDashboardModalLayer = entry => {
  const existingIndex = openDashboardModalLayers.indexOf(entry);
  if (existingIndex >= 0) openDashboardModalLayers.splice(existingIndex, 1);

  entry.isTopmost.value = false;
  syncDashboardModalStackState();
};

export const getTopmostDashboardModalLayer = () =>
  openDashboardModalLayers.at(-1) || null;

export const wasDashboardModalEscapeHandled = event =>
  handledDashboardModalEscapeEvents.has(event);

export const markDashboardModalEscapeHandled = event => {
  handledDashboardModalEscapeEvents.add(event);
};
